module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sessao-coberturas"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_c('icon', {
    attrs: {
      "name": "bar-chart"
    }
  }), _vm._v(" Coberturas")], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.new_property')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.new_property"
    }
  }, [_vm._v("Valor de Novo")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coverage.new_property),
      expression: "coverage.new_property"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.coverage.new_property"
    },
    domProps: {
      "checked": Array.isArray(_vm.coverage.new_property) ? _vm._i(_vm.coverage.new_property, null) > -1 : (_vm.coverage.new_property)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.coverage.new_property,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.coverage.new_property = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.coverage.new_property = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.coverage, "new_property", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  })])]), _vm._v(" "), (_vm.errors.has('data.coverage.new_property')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.new_property')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.assistance')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.assistance"
    }
  }, [_vm._v(_vm._s(_vm.assists.label) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    key: _vm.coverage.assistance,
    staticClass: "vueSelect",
    attrs: {
      "options": _vm.assists.options,
      "label": "text",
      "filterable": true,
      "reduce": function (x) { return x.id; },
      "name": "data.coverage.assistance",
      "id": _vm.assists.id,
      "placeholder": _vm.assists.placeholder,
      "data-vv-as": _vm.assists.label
    },
    model: {
      value: (_vm.coverage.assistance),
      callback: function($$v) {
        _vm.$set(_vm.coverage, "assistance", $$v)
      },
      expression: "coverage.assistance"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("Digite 3 ou mais caracteres para buscar")])]), _vm._v(" "), (_vm.errors.has('data.coverage.assistance')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.assistance')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.sum')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.sum"
    }
  }, [_vm._v(_vm._s(_vm.funds.label) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    key: _vm.coverage.sum,
    staticClass: "vueSelect",
    attrs: {
      "options": _vm.funds.options,
      "label": "text",
      "filterable": true,
      "reduce": function (x) { return x.id; },
      "name": "data.coverage.sum",
      "id": _vm.funds.id,
      "placeholder": _vm.funds.placeholder,
      "data-vv-as": _vm.funds.label
    },
    model: {
      value: (_vm.coverage.sum),
      callback: function($$v) {
        _vm.$set(_vm.coverage, "sum", $$v)
      },
      expression: "coverage.sum"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("Digite 3 ou mais caracteres para buscar")])]), _vm._v(" "), (_vm.errors.has('data.coverage.sum')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.sum')))]) : _vm._e()], 1)]), _vm._v(" "), (['BUILDING_CONTENT', 'BUILDING'].includes(_vm.coverage.sum)) ? _c('div', {
    class: ['BUILDING_CONTENT'].includes(_vm.coverage.sum) ? 'col-xs-12 col-md-2' : 'col-xs-12 col-md-4'
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.building_value')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.building_value"
    }
  }, [_vm._v("Valor do Edifício")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.building_value),
      expression: "coverage.building_value",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.building_value",
      "id": "data.coverage.building_value",
      "data-vv-as": "Valor edifício"
    },
    domProps: {
      "value": (_vm.coverage.building_value)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "building_value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data.coverage.building_value')),
      expression: "errors.has('data.coverage.building_value')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.building_value')))])])]) : _vm._e(), _vm._v(" "), (['BUILDING_CONTENT', 'CONTENT'].includes(_vm.coverage.sum)) ? _c('div', {
    class: ['BUILDING_CONTENT'].includes(_vm.coverage.sum) ? 'col-xs-12 col-md-2' : 'col-xs-12 col-md-4'
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.content_value')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.content_value"
    }
  }, [_vm._v("Valor do Conteúdo")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.content_value),
      expression: "coverage.content_value",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.content_value",
      "id": "data.coverage.content_value",
      "data-vv-as": "Valor conteúdo"
    },
    domProps: {
      "value": (_vm.coverage.content_value)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "content_value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data.coverage.content_value')),
      expression: "errors.has('data.coverage.content_value')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.content_value')))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.basic')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.basic"
    }
  }, [_vm._v("Básica (Incêndio, Raio, Explosão)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.basic),
      expression: "coverage.basic",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.basic",
      "id": "data.coverage.basic",
      "data-vv-as": "Básica"
    },
    domProps: {
      "value": (_vm.coverage.basic)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "basic", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.basic')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.basic')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.electrical_damages')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.electrical_damages"
    }
  }, [_vm._v("Danos elétricos")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.electrical_damages),
      expression: "coverage.electrical_damages",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.electrical_damages",
      "id": "data.coverage.electrical_damages",
      "data-vv-as": "Danos elétricos"
    },
    domProps: {
      "value": (_vm.coverage.electrical_damages)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "electrical_damages", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.electrical_damages')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.electrical_damages')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.glasses')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.glasses"
    }
  }, [_vm._v("Vidros")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.glasses),
      expression: "coverage.glasses",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.glasses",
      "id": "data.coverage.glasses",
      "data-vv-as": "Vidros"
    },
    domProps: {
      "value": (_vm.coverage.glasses)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "glasses", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.glasses')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.glasses')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.theft_goods')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.theft_goods"
    }
  }, [_vm._v("Roubos de Bens")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.theft_goods),
      expression: "coverage.theft_goods",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.theft_goods",
      "id": "data.coverage.theft_goods",
      "data-vv-as": "Roubos de Bens"
    },
    domProps: {
      "value": (_vm.coverage.theft_goods)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "theft_goods", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.theft_goods')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.theft_goods')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.theft_values')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.theft_values"
    }
  }, [_vm._v("Roubo de Valores")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.theft_values),
      expression: "coverage.theft_values",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.theft_values",
      "id": "data.coverage.theft_values",
      "data-vv-as": "Roubo de Valores"
    },
    domProps: {
      "value": (_vm.coverage.theft_values)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "theft_values", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.theft_values')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.theft_values')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.equipments')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.equipments"
    }
  }, [_vm._v("Equipamentos")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.equipments),
      expression: "coverage.equipments",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.equipments",
      "id": "data.coverage.equipments",
      "data-vv-as": "Equipamentos"
    },
    domProps: {
      "value": (_vm.coverage.equipments)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "equipments", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.equipments')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.equipments')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.wind')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.wind"
    }
  }, [_vm._v("Vendaval")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.wind),
      expression: "coverage.wind",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.wind",
      "id": "data.coverage.wind",
      "data-vv-as": "Vendaval"
    },
    domProps: {
      "value": (_vm.coverage.wind)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "wind", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.wind')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.wind')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.vehicle_impact')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.vehicle_impact"
    }
  }, [_vm._v("Impacto de veículos")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.vehicle_impact),
      expression: "coverage.vehicle_impact",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.vehicle_impact",
      "id": "data.coverage.vehicle_impact",
      "data-vv-as": "Impacto de veículos"
    },
    domProps: {
      "value": (_vm.coverage.vehicle_impact)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "vehicle_impact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.vehicle_impact')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.vehicle_impact')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.landslip')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.landslip"
    }
  }, [_vm._v("Desmoronamento")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.landslip),
      expression: "coverage.landslip",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.landslip",
      "id": "covdata[coverage][landslip]erage_landslip",
      "data-vv-as": "Desmoronamento"
    },
    domProps: {
      "value": (_vm.coverage.landslip)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "landslip", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.landslip')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.landslip')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.adverts')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.adverts"
    }
  }, [_vm._v("Anúncios/Letreiros")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.adverts),
      expression: "coverage.adverts",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.adverts",
      "id": "data.coverage.adverts",
      "data-vv-as": "Anúncios/Letreiros"
    },
    domProps: {
      "value": (_vm.coverage.adverts)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "adverts", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.adverts')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.adverts')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.rent_payment')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.rent_payment"
    }
  }, [_vm._v("Aluguel")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.rent_payment),
      expression: "coverage.rent_payment",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.rent_payment",
      "id": "coverage_rent_payment",
      "data-vv-as": "Aluguel"
    },
    domProps: {
      "value": (_vm.coverage.rent_payment)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "rent_payment", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.rent_payment')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.rent_payment')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.turmoil')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.turmoil"
    }
  }, [_vm._v("Tumulto/Greve")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.turmoil),
      expression: "coverage.turmoil",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.turmoil",
      "id": "coverage_turmoil",
      "data-vv-as": "Tumulto/Greve"
    },
    domProps: {
      "value": (_vm.coverage.turmoil)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "turmoil", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.turmoil')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.turmoil')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.recomposition_documents')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.recomposition_documents"
    }
  }, [_vm._v("Rec. Documentos")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.recomposition_documents),
      expression: "coverage.recomposition_documents",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.recomposition_documents",
      "id": "data.coverage.recomposition_documents",
      "data-vv-as": "Rec. Documentos"
    },
    domProps: {
      "value": (_vm.coverage.recomposition_documents)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "recomposition_documents", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.recomposition_documents')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.recomposition_documents')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.liability_operations')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.liability_operations"
    }
  }, [_vm._v("RC Operações")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.liability_operations),
      expression: "coverage.liability_operations",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.liability_operations",
      "id": "data.coverage.liability_operations",
      "data-vv-as": "RC Operações"
    },
    domProps: {
      "value": (_vm.coverage.liability_operations)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "liability_operations", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.liability_operations')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.liability_operations')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.liability_employer')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.liability_employer"
    }
  }, [_vm._v("RC Empregador")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.liability_employer),
      expression: "coverage.liability_employer",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.liability_employer",
      "id": "data.coverage.liability_employer",
      "data-vv-as": "RC Empregador"
    },
    domProps: {
      "value": (_vm.coverage.liability_employer)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "liability_employer", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.liability_employer')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.liability_employer')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.moral_damages')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.moral_damages"
    }
  }, [_vm._v("Danos Morais")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.moral_damages),
      expression: "coverage.moral_damages",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.moral_damages",
      "id": "data.coverage.moral_damages",
      "data-vv-as": "Danos Morais"
    },
    domProps: {
      "value": (_vm.coverage.moral_damages)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "moral_damages", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.moral_damages')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.moral_damages')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.fixed_expenses')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.fixed_expenses"
    }
  }, [_vm._v("Despesas Fixas")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.fixed_expenses),
      expression: "coverage.fixed_expenses",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.fixed_expenses",
      "id": "data.coverage.fixed_expenses",
      "data-vv-as": "Despesas Fixas"
    },
    domProps: {
      "value": (_vm.coverage.fixed_expenses)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "fixed_expenses", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.fixed_expenses')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.fixed_expenses')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.business_interruption')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.business_interruption"
    }
  }, [_vm._v("Lucros Cessantes")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.business_interruption),
      expression: "coverage.business_interruption",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.business_interruption",
      "id": "data.coverage.business_interruption",
      "data-vv-as": "Lucros Cessantes"
    },
    domProps: {
      "value": (_vm.coverage.business_interruption)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "business_interruption", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), (_vm.errors.has('data.coverage.business_interruption')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.business_interruption')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.leaks')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.leaks"
    }
  }, [_vm._v("Vazamentos")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.leaks),
      expression: "coverage.leaks",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.leaks",
      "id": "data.coverage.leaks",
      "data-vv-as": "Vazamentos"
    },
    domProps: {
      "value": (_vm.coverage.leaks)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "leaks", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data.coverage.leaks')),
      expression: "errors.has('data.coverage.leaks')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.leaks')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.shower')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.shower"
    }
  }, [_vm._v("Chuveiro/Sprinkler")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.shower),
      expression: "coverage.shower",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.shower",
      "id": "data.coverage.shower",
      "data-vv-as": "Chuveiro/Sprinkler"
    },
    domProps: {
      "value": (_vm.coverage.shower)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "shower", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data.coverage.shower')),
      expression: "errors.has('data.coverage.shower')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.coverage.shower')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.coverage.loyalty')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.coverage.loyalty"
    }
  }, [_vm._v("Fidelidade")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.coverage.loyalty),
      expression: "coverage.loyalty",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.coverage.loyalty",
      "id": "data.coverage.loyalty",
      "data-vv-as": "Fidelidade"
    },
    domProps: {
      "value": (_vm.coverage.loyalty)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.coverage, "loyalty", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(",00")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data.coverage.loyalty')),
      expression: "errors.has('data.coverage.loyalty')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data[coverage][loyalty]')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1108997c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/Coverage/FormPartialCoverage.vue
// module id = 330
// module chunks = 0